export default {
  general: {
    button: {
      ok: "OK",
      cancel: "キャンセル",
      close: "閉じる",
      save: "保存",
      add: "追加",
      delete: "削除",
      language: "lang",
      logout: "ログアウト",
      toHome: "To Home",
    },
    notify: {
      error: {
        loading: "読込中は更新できません",
        failedRequest: "リクエストの構築に失敗しました",
        request: {
          sessionExpired: "ログインセッションの有効期限を超過しています",
          login: "ログインに失敗しました",
          logout: "ログアウトに失敗しました",
          publishers: "パブリッシャーのデータ取得に失敗しました",
          clients: "クライアントのデータ取得に失敗しました",
          latestDataDate: "最新データの日付取得に失敗しました",
          adData: "Estimated Revenue, Impression, eCPMのデータ取得に失敗しました",
          overallTrends: "全体推移のデータ取得に失敗しました",
          demandSales: "デマンド別売上のデータ取得に失敗しました",
          cpmTransitions: "CPM推移のデータ取得に失敗しました",
          auctionTimes: "Auction Timeのデータ取得に失敗しました",
          analyticsReport: "レポートのデータ取得に失敗しました",
          dimensions: "ディメンションの取得に失敗しました",
          metrics: "メトリクスの取得に失敗しました",
          adUnits: "Adunitのデータ取得に失敗しました",
          adUnitGroups: "AdunitGroupのデータ取得に失敗しました",
          bidders: "Bidderのデータ取得に失敗しました",
          domains: "ドメインのデータ取得に失敗しました",
          users: "ユーザーのデータ取得に失敗しました",
          fieldData: "フィールドデータ取得に失敗しました",
          labData: "ラボデータ取得に失敗しました",
          fieldDataTransitions: "日別フィールドデータグラフの取得に失敗しました",
          cwvDomains: {
            recordCountOverflow: "1パブリッシャーにつき11件以上の CWV ドメインは登録できません",
            duplicateRecord:
              "指定のパブリッシャーには既に同名の CWV ドメインが存在するため、登録できません",
          },
        },
      },
    },
    text: {
      appTitle: "AutoStream",
      routeGuardDialog: {
        title: "確認",
        text: "保存していない場合、編集した内容は失われます。よろしいですか？",
      },
      userInfo: {
        name: "user",
        email: "email",
      },
    },
    tooltip: {
      browserBackAnnotation: "保存していない場合、ページ移動すると編集した内容は失われます",
    },
    report: {
      downloadDialog: {
        title: "レポートダウンロード",
        saveAndDownload: "レポート設定の保存とダウンロードを行います",
        download: "レポートのダウンロードを行います",
        downloadAnnotation: "この操作には時間がかかります",
        adhocDownloadAnnotation: "編集した内容は保存されません。この操作には時間がかかります。",
        saving: "レポート設定の保存中...",
        generating: "レポートを生成中...",
        downloading: "生成されたレポートのダウンロード中...",
      },
      downloadDialogForSafari: {
        title: "レポートのダウンロードが完了しました",
        link: "ダウンロードリンク",
        howToDownload: "Safari の DL手順",
        rClickToLink: "ダウンロードリンクを右クリック",
        clickToDownload: "「リンク先のファイルをダウンロード」をクリック",
        close: "閉じる",
      },
    },
  },
};
